export const pageList = [
    { text: 'Студенту', href: '#Career-opportunities' },
    { text: 'Абитуриенту', href: '#Admission' },
    { text: 'Сотрудничество', href: '#Cooperation' },
]
